
	import { Inject, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import { LROptionsWithoutNone, SHELL_SPECIAL_RX } from '@/store/prescription/prescription-types';
	import CategoryContainer from '@/components/new-prescription/prescription-categories/CategoryContainer.vue';
	import PrescriptionItemRadioSelect from '@/components/new-prescription/prescription-items/PrescriptionItemRadioSelect.vue';
	import PrescriptionItemCheckbox from '@/components/new-prescription/prescription-items/PrescriptionItemCheckbox.vue';
	import PrescriptionItemSelect from '@/components/new-prescription/prescription-items/PrescriptionItemSelect.vue';
	import shellModification from '@/store/prescription/definition/categories/shellModification';
	import PrescriptionItemRadio from '@/components/new-prescription/prescription-items/PrescriptionItemRadio.vue';
	import OtherModifications from '@/components/prescription/OtherModifications.vue';
	import { PrescriptionEventHandler } from '@/components/new-prescription/PrescriptionForm.vue';
	import { LROptions } from '@/store/prescription/prescription-types';
	import PrescriptionItemSpecialRX from '@/components/new-prescription/prescription-items/PrescriptionItemSpecialRX.vue';
	import PrescriptionItemExtendedSelectLR from '@/components/new-prescription/prescription-items/PrescriptionItemExtendedSelectLR.vue';
	import PrescriptionItemSelectLR from '@/components/new-prescription/prescription-items/PrescriptionItemSelectLR.vue';
	import PrescriptionItemRadioSelectExtended from '@/components/new-prescription/prescription-items/PrescriptionItemRadioSelectExtended.vue';
	import { LRRadioWithoutNone } from '@/store/prescription/definition/categories/prescriptionCategoriesDefinition';
	import { getDisabledValuesBySideForProp } from '@/store/prescription/prescription-utils';

	type MortonList = 'mortonsExtension' | 'reverseMortonsExtension' | 'firstRayCutout' | 'cutoutAndFirst';

	@Observer
	@Component({
		components: {
			PrescriptionItemRadioSelectExtended,
			PrescriptionItemSelectLR,
			PrescriptionItemExtendedSelectLR,
			PrescriptionItemSpecialRX,
			PrescriptionItemRadioSelect,
			PrescriptionItemCheckbox,
			PrescriptionItemSelect,
			PrescriptionItemRadio,
			CategoryContainer,
			OtherModifications
		}
	})
	export default class ShellModifications extends Vue {
		@Inject() eventHandler!: PrescriptionEventHandler;

		private readonly disableMapping: Record<MortonList, Array<MortonList>> = {
			cutoutAndFirst: ['mortonsExtension', 'reverseMortonsExtension'],
			firstRayCutout: ['mortonsExtension'],
			mortonsExtension: ['reverseMortonsExtension', 'firstRayCutout', 'cutoutAndFirst'],
			reverseMortonsExtension: ['mortonsExtension', 'cutoutAndFirst']
		};
		activated() {
			if (this.$route.query['showhelpmodal'] === 'true') {
				this.$state.prescription.setShowHelpSaverxModal('true');
			}
		}

		get shellSpecialRX() {
			return SHELL_SPECIAL_RX;
		}
		deactivated() {
			this.$state.prescription.setShowHelpSaverxModal('false');
		}

		get shell() {
			return shellModification;
		}

		private init() {
			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.firstRayCutout,
				'side',
				'none',
				() => (this.$state.prescription.newPrescription.shellModifications.firstRayCutout.value = undefined)
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.firstRayCutout,
				'side',
				['left', 'right', 'both'],
				() => {
					if (this.$state.prescription.newPrescription.shellModifications.firstRayCutout.value === undefined) {
						this.$state.prescription.newPrescription.shellModifications.firstRayCutout.value = '45deg';
					}
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.medialFlange,
				'side',
				'none',
				() => (this.$state.prescription.newPrescription.shellModifications.medialFlange.value = undefined)
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.medialFlange,
				'side',
				['left', 'right', 'both'],
				() => {
					if (this.$state.prescription.newPrescription.shellModifications.medialFlange.value === undefined) {
						this.$state.prescription.newPrescription.shellModifications.medialFlange.value = 'medium';
					}
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.lateralFlange,
				'side',
				'none',
				() => (this.$state.prescription.newPrescription.shellModifications.lateralFlange.value = undefined)
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.lateralFlange,
				'side',
				['left', 'right', 'both'],
				() => {
					if (this.$state.prescription.newPrescription.shellModifications.lateralFlange.value === undefined) {
						this.$state.prescription.newPrescription.shellModifications.lateralFlange.value = 'low';
					}
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.reverseMortonsExtension,
				'side',
				['left', 'right', 'both'],
				() => {
					if (this.$state.prescription.newPrescription.shellModifications.reverseMortonsExtension.value === undefined) {
						this.$state.prescription.newPrescription.shellModifications.reverseMortonsExtension.value = 'consistent';
					}
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.shellModifications.mortonsExtension,
				'side',
				['left', 'right', 'both'],
				() => {
					if (this.$state.prescription.newPrescription.shellModifications.mortonsExtension.value === undefined) {
						this.$state.prescription.newPrescription.shellModifications.mortonsExtension.value = 'consistent';
					}
				}
			);
		}

		created() {
			this.eventHandler.addInitializationFunction(this.init.bind(this.eventHandler));
		}

		getDisabledMorton(type: MortonList) {
			const disabledOptionsList: Array<any> = [];
			for (const option of this.disableMapping[type]) {
				if (option === 'firstRayCutout') {
					const value = this.$state.prescription.newPrescription.shellModifications[option].side;
					if (value !== 'none') {
						disabledOptionsList.push('both');
						if (value === 'both') {
							disabledOptionsList.push('flexible');
							disabledOptionsList.push('semi-rigid');
							disabledOptionsList.push('rigid');
						} else {
							disabledOptionsList.push(value);
						}
					}
				} else if (option === 'cutoutAndFirst') {
					const value = this.$state.prescription.newPrescription.shellModifications[option];
					if (value !== 'none') {
						disabledOptionsList.push('both');
						if (value === 'both') {
							disabledOptionsList.push('flexible');
							disabledOptionsList.push('semi-rigid');
							disabledOptionsList.push('rigid');
						} else {
							disabledOptionsList.push(value);
						}
					}
				} else {
					let value = (this.$state.prescription.newPrescription.shellModifications[option] as any).type;
					if (value !== 'none') {
						value = this.$state.prescription.newPrescription.shellModifications[option].side;
						disabledOptionsList.push('both');
						if (value === 'both') {
							disabledOptionsList.push('left');
							disabledOptionsList.push('right');
							disabledOptionsList.push('flexible');
							disabledOptionsList.push('semi-rigid');
							disabledOptionsList.push('rigid');
						} else {
							disabledOptionsList.push(value);
						}
					}
				}
			}
			if (type === 'mortonsExtension' || type === 'reverseMortonsExtension') {
				if (this.$state.prescription.newPrescription.shellModifications.shellLength !== 'met') {
					disabledOptionsList.push('left');
					disabledOptionsList.push('right');
				}
				if (this.$state.prescription.newPrescription.topCovers.topCoverLength !== 'full') {
					disabledOptionsList.push('left');
					disabledOptionsList.push('right');
				}
			}
			if (disabledOptionsList.includes('left') && disabledOptionsList.includes('right')) {
				disabledOptionsList.push('both');
				disabledOptionsList.push('flexible');
				disabledOptionsList.push('semi-rigid');
				disabledOptionsList.push('rigid');
			}

			if (type === 'firstRayCutout') {
				const values = ['none', 'left', 'right', 'both'].filter((el) => !disabledOptionsList.includes(el));
				if (values.length === 1) {
					this.$state.prescription.newPrescription.shellModifications[type].side = values[0] as LROptions;
				}
			} else if (type === 'cutoutAndFirst') {
				const values = ['none', 'left', 'right', 'both'].filter((el) => !disabledOptionsList.includes(el));
				if (values.length === 1) {
					this.$state.prescription.newPrescription.shellModifications[type] = values[0] as LROptions;
				}
			} else {
				const values = ['left', 'right', 'both'].filter((el) => !disabledOptionsList.includes(el));
				if (values.length === 1) {
					this.$state.prescription.newPrescription.shellModifications[type].side = values[0] as LROptionsWithoutNone;
				}
			}

			return disabledOptionsList;
		}

		shellLengthDisabledValues() {
			const disabledOptionsList: Array<any> = [];
			const hasDisabler =
				this.$state.prescription.newPrescription.shellModifications.mortonsExtension.type !== 'none' ||
				this.$state.prescription.newPrescription.shellModifications.reverseMortonsExtension.type !== 'none' ||
				this.$state.prescription.newPrescription.shellModifications.firstRayCutout.side !== 'none' ||
				this.$state.prescription.newPrescription.topCovers.topCoverLength === 'met';
			if (hasDisabler) {
				disabledOptionsList.push('full');
				disabledOptionsList.push('sulcus');
				this.$state.prescription.newPrescription.shellModifications.shellLength = 'met';
			}
			if (this.$state.prescription.newPrescription.topCovers.topCoverLength === 'sulcus') {
				disabledOptionsList.push('full');
			}
			return disabledOptionsList;
		}

		firstRayCutoutDisabledValues() {
			const morton = this.getDisabledMorton('firstRayCutout');
			const sides = getDisabledValuesBySideForProp(this.$state, 'firstRayCutout');
			return Array.from(new Set([...morton, ...sides]));
		}

		mortonsDisabledValues() {
			return this.getDisabledMorton('mortonsExtension');
		}

		reverseDisabledValues() {
			return this.getDisabledMorton('reverseMortonsExtension');
		}

		cutoutAndFirstDisabledValues() {
			const morton = this.getDisabledMorton('cutoutAndFirst');
			const sides = getDisabledValuesBySideForProp(this.$state, 'cutoutAndFirst');
			const cutout = this.cutoutDisabledValues('cutoutAndFirst');
			return Array.from(new Set([...morton, ...sides, ...cutout]));
		}

		cutoutAndStyloidDisabledValues() {
			const sides = getDisabledValuesBySideForProp(this.$state, 'cutoutAndStyloid');
			const cutout = this.cutoutDisabledValues('cutoutAndStyloid');
			return Array.from(new Set([...sides, ...cutout]));
		}

		wellAndStyloidDisabledValues() {
			return getDisabledValuesBySideForProp(this.$state, 'wellAndStyloid');
		}

		cutoutDisabledValues(type: string) {
			const cutouts = ['heelCutout', 'cutoutAndStyloid', 'cutoutAndFirst', 'cutoutFifth'];
			let left = 0,
				right = 0;
			const disabledValues: Array<any> = [];
			for (const key of cutouts) {
				if (key === type) {
					continue;
				}
				switch (this.$state.prescription.newPrescription.shellModifications[key]) {
					case 'left':
						left++;
						break;
					case 'right':
						right++;
						break;
					case 'both':
						left++;
						right++;
						break;
				}
			}
			if (left >= 2) {
				disabledValues.push('left');
				disabledValues.push('both');
			}
			if (right >= 2) {
				disabledValues.push('right');
				disabledValues.push('both');
			}
			return disabledValues;
		}
	}
